import { css } from 'linaria';

export const imageWithZoomContainer = css`
  position: relative;
  width: 586px;
  height: 586px;
  overflow: hidden;

  @media (--only-largeDesktop) {
    margin-top: 40px;
  }

  @media (--only-desktop) {
    width: 440px;
    height: 440px;
    margin-top: 38px;
  }

  @media (--only-tablet) {
    width: 600px;
    height: 620px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
  }
`;

export const image = css`
  && {
    width: 586px;
    height: 586px;

    @media (--only-desktop) {
      width: 440px;
      height: 440px;
    }

    @media (--only-tablet) {
      width: 600px;
      height: 600px;
    }

    @media (--only-mobile) {
      width: 100%;
      height: 100%;
    }
  }
`;

export const imageWithZoom = css`
  position: absolute;
  z-index: 10;
  background-repeat: no-repeat;

  @media (--to-desktop) {
    display: none;
  }
`;
